import React from 'react';
import './App.scss';
import {observer, inject,} from 'mobx-react';
import StrBeforeHash from './StrBeforeHash/StrBeforeHash';
import mainStore from '../stores/mainStore';
import Tabs from "./tabs/Tabs";
import Tab from "./tabs/Tab";
import ReqInfo from "./ReqInfo/ReqInfo";
import ResInfo from "./ResInfo/ResInfo";
import Button from "./E-button/Button";
import CodeExample from "./CodeExample/CodeExample";
import SettingsBlock from "./SettingsBlock/SettingsBlock";


const App = inject("mainStore", "AllInputsStore", "AllInputsBlocksStore")(observer((props) => {
    const store = props.mainStore;
    const inputs = props.AllInputsStore.inputs;
    const blocksStore = props.AllInputsBlocksStore;
    const isInputsLoading = props.AllInputsStore.isLoading;

    /*Buttons ------------------------------------------> */

    const renderSubmitBtn = () => {
        return <Button
            type="submit"
            onClick={store.submitData}
            className={store.submitBtnClass}
        >
            Submit
        </Button>;
    };

    const renderClearSettingsBtn = () => {
        return <Button
            type="button"
            onClick={store.clearSettings}
            className={"btn"}
        >
            Clear
        </Button>;
    };

    const renderUseSignBtn = () => {
        return (
            <Button
                className="btn btn_size_sm btn_color_secondary"
                onClick={store.useGeneratedSign}
            >
                USE
            </Button>
        )
    };

    /*Buttons <------------------------------------------ */

    const renderSettingFields = () => {
        if (isInputsLoading) {
            return 'Is settings loading...';
        }
        const inputBlockStores = Object.values(blocksStore.inputsBlocks);
        const inputBlockList = inputBlockStores.map((inputBlock) => {
            return (
                <SettingsBlock key={inputBlock.title} data={inputBlock}></SettingsBlock>
            )
        });
        return <div className="app__settings-blocks">
            {inputBlockList}
        </div>;
    };

    const renderCodeExampleTabs = () => {
        const method = 'post';

        return (
            <Tabs>
                <Tab title="Curl">
                    <CodeExample
                        lang='curl'
                        url={store.url}
                        method={method}
                        data={store.userParams}
                        headers={store.headers}
                        paramsType={inputs['contenttype'].value}
                    />
                </Tab>
                <Tab title="PHP">
                    <CodeExample
                        lang='php'
                        url={store.url}
                        method={method}
                        data={store.userParams}
                        headers={store.headers}
                        paramsType={inputs['contenttype'].value}
                        secretKey={inputs['secretKey'].value}
                    />
                </Tab>
                <Tab title="Python">
                    <CodeExample
                        lang='python'
                        url={store.url}
                        method={method}
                        data={store.userParams}
                        headers={store.headers}
                        paramsType={inputs['contenttype'].value}
                        secretKey={inputs['secretKey'].value}
                    />
                </Tab>
                <Tab title="Link">
                    <CodeExample
                        lang='link'
                        url={store.url}
                        method={method}
                        data={store.userParams}
                        headers={store.headers}
                        paramsType={inputs['contenttype'].value}
                    />
                </Tab>
            </Tabs>
        )
    };


    const renderRequestInfo = () => {
        if (!store.isShowInputList) return null;
        if (isInputsLoading) {
            return 'loading info...';
        }


        return (
            <div className="app__request-info">
                <div className="app__request-info-elem">
                    <ReqInfo title="String Before Hash">
                        <StrBeforeHash params={mainStore.sortedUserParams} sk={inputs['secretKey'].value}></StrBeforeHash>
                    </ReqInfo>
                </div>
                <div className="app__request-info-elem">
                    <ReqInfo title="Sign">
                        <div className="sign">{store.sign}</div>
                    </ReqInfo>
                </div>
                <div className="app__request-info-elem">
                    <ReqInfo title="Request">
                        {renderCodeExampleTabs()}
                    </ReqInfo>
                </div>
            </div>
        );
    };

    const renderResponseInfo = () => {
        if (!store.response && !store.error) return null;
        const data = {
            res: store.response,
            err: store.error,
        }
        return (
            <div className="app__response-info">
                <ResInfo data={data}/>
            </div>);
    };

    const renderSettings = () => {

        const handleFormChange = () => {
            store.error = null;
            store.response = null;
        }
        const renderRequestSettingsButtons = () => {
            return (
                <div className="req-settings__btns">
                    <div className="req-settings__btn">
                        {renderSubmitBtn()}
                    </div>
                    <div className="req-settings__btn">
                        {renderClearSettingsBtn()}
                    </div>
                </div>);
        }
        const renderRequestSettingsHeader = () => {
            return (
                <header className="req-settings__header">
                    <h2 className="req-settings__title">Parameters</h2>
                </header>
            )
        };
        return (
            <form
                onSubmit={store.cancelSubmit}
                onChange={handleFormChange}
                className="app__settings app-settings"
            >
                {renderRequestSettingsHeader()}
                {renderSettingFields()}
                {renderRequestSettingsButtons()}
            </form>
        )
    }


    return (
        <div className="app">
            {renderSettings()}
            <div className="app__result">
                {renderRequestInfo()}
                {renderResponseInfo()}
            </div>
        </div>
    );
}));

export default App;
